import React, { useState, useEffect, useRef } from 'react';
import { Link, Navigate, useNavigate, Routes, Route } from "react-router-dom";
import axios from 'axios';
import Swal from 'sweetalert2';
import MasterDashboardLayout from '../../AdminPanel/MasterDashboardLayout'

import { DataGrid } from '@mui/x-data-grid';

function ViewUserContact() {
    const navigate = useNavigate();
    const [renderData, setRenderData] = useState('')
    const columns = [
        { field: 'id', headerName: 'ID',  padding: 50 },
        { field: 'name', headerName: 'Name' ,flex:1},
        { field: 'email', headerName: 'Email',flex:1 },
        { field: 'phone_no', headerName: 'Phone',flex:1 },
        { field: 'message', headerName: 'Message',flex:1 },

        {
            headerName: 'Action',
            renderCell: (params) =>
                <div class="fs-6" style={{ cursor: 'pointer' }}>
                    <i class="fa text-danger fa-trash mx-2" onClick={(e) => deleteUserContact(e, params.id)}></i>
                </div>
        },
    ];

    const [allContactUs, setAllContactUs] = useState([]);
    console.log('all testi', allContactUs)
    useEffect(() => {
        axios.get(`/api/user-contact-info`).then(res => {
            if (res.data.status == 200) {
                setAllContactUs(res.data.all_contact_us);
                // setLoading(false);

            }
        })
    }, [renderData])

    //delete functionality start 

    const deleteUserContact = (e, id) => {
        e.preventDefault();
        const thisClicked = e.currentTarget;
        //  thisClicked.innerText = "Deleting";

        Swal.fire({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!'
        }).then((result) => {
            if (result.isConfirmed) {
                axios.post(`/api/delete-user-contact-info/${id}`).then(res => {
                    if (res.data.status === 200) {
                        setRenderData(res.data)
                        thisClicked.closest("tr").remove();

                        //   swal("Success", res.data.message, "success");
                    }
                });
                Swal.fire(
                    'Deleted!',
                    'Your data has been deleted.',
                    'success'
                )
            }
        })

    }


    return (
        <MasterDashboardLayout>
            <div class="col-12 grid-margin stretch-card">
                <div class="card">
                    <div class="card-body">
                        <div className='d-flex justify-content-between my-2'>
                            <h4 class="card-title">View User Contact Information</h4>
                        </div>

                        <div style={{ height: '70vh', width: '100%' }}>
                            <DataGrid
                                rows={allContactUs}
                                columns={columns}
                                pageSize={5}
                                rowHeight={100}
                                rowsPerPageOptions={[5]}
                            // checkboxSelection
                            />
                        </div>
                    </div>
                </div>
            </div>
        </MasterDashboardLayout>
    )
}

export default ViewUserContact